import { Box } from "@mui/material";
import { NavBar } from "../navbar";
import { ContactUsSection } from "../contact";
import { HoukPaper } from "./components";
import Hero from "../hero";

import { useEffect } from "react";

export default function HereditaryCareAI() {
  useEffect(() => {
    document.title = "AI in Cancer Genetics";
  }, []);

  return (
    <Box sx={{ margin: 0, padding: 0 }}>
      <NavBar />
      <Hero
        image="/update4.jpg"
        title="AI in Cancer Genetics"
        blurb="Artificial Intelligence is transforming hereditary cancer care by making
        complex genetic information easier to understand. Combining AI tools
        like ChatGPT with expert review improves communication, saves time, and
        empowers patients to make informed health decisions."
      />
      <HoukPaper />
      <ContactUsSection />
    </Box>
  );
}
